import React, { FC, useMemo } from 'react';

import { Typography } from '../../../../shared/typography';
import Select from '../../../select';

interface IInputProps {
	title: string;
	value: any;
	fields: any;
	callback(props: any): void;
}

const Grouping: FC<IInputProps> = ({ title, value, fields, callback }) => {
	const setTitle = (type: string): string => {
		const regex = /\d+/;
		let result = type.replace(/([A-Z])/g, ' $1');
		const number = result.match(regex);
		result = number ? result.replace(number[0], ` ${number[0]}`) : result;
		return result.charAt(0).toLowerCase() + result.slice(1).toLowerCase();
	};

	const level1 = useMemo(
		() =>
			[...new Set(['NoGrouping', ...fields])].map((field: any) => ({
				title: setTitle(field),
				value: field,
			})),
		[fields]
	);

	const level2 = useMemo(
		() =>
			[...new Set(['NoGrouping', ...fields])].map(field => ({
				title: setTitle(field),
				value: field,
			})),

		[fields]
	);

	const groups = useMemo(
		() => [
			{
				title: 'Grouping level 1',
				data: level1,
				field: 'groupingLevel1',
			},
			{
				title: 'Grouping level 2',
				data: level2,
				field: 'groupingLevel2',
			},
		],
		[level1, level2]
	);

	if (!value) return null;

	return (
		<div style={{ width: '100%' }}>
			<div>
				<Typography type="bold" size="medium" text={title} />
			</div>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				{groups.map((group, i) => {
					const newValue = group.data.find(
						(option: any) => option.value === value[group.field]
					);
					return (
						<div key={i}>
							<Select
								options={group.data}
								callback={(option: any) =>
									callback({ [group.field]: option.value })
								}
								value={newValue?.title || group.title}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Grouping;
